import { BaseMaskAdapter } from "./base-adapter";

export class GenericMaskAdapter extends BaseMaskAdapter {
  formatForDisplay(value: unknown): string {
    if (this.isEmpty(value)) {
      return "";
    }
    return this.applyGenericMask(String(value));
  }

  parseFromInput(inputValue: string): { value: string; formatted: string } {
    if (inputValue === "" || this.cleanValue(inputValue) === "") {
      return { value: "", formatted: "" };
    }

    const formatted = this.applyGenericMask(inputValue);

    // For decimal masks (like "99,99" for percentage), preserve decimal format
    if (this.maskPattern.includes(",") && /^\d+,\d+$/.test(this.maskPattern)) {
      // Convert Brazilian decimal format to US format (e.g., "30,50" -> "30.50")
      const cleanValue = formatted.replace(",", ".");
      return { value: cleanValue, formatted };
    } else {
      const cleanValue = this.cleanValue(formatted);
      return { value: cleanValue, formatted };
    }
  }

  handleControlledUpdate(value: unknown): string {
    if (this.isEmpty(value)) {
      return "";
    }
    return this.applyGenericMask(String(value));
  }

  isKeyAllowed(key: string): boolean {
    if (this.isControlKey(key)) {
      return true;
    }
    // If mask contains # (alphanumeric), allow letters and digits
    // If mask only contains 9 (digits), allow only digits
    if (this.maskPattern.includes("#")) {
      return /^[a-zA-Z0-9]$/.test(key);
    }
    return /^\d$/.test(key);
  }
}
